import axios from 'axios'
import global from '@/global/variable.js'

// 获取消息推送列表
export function getList(data) {
  const url = global.requestUrl + '/projectConfig/list'
  return axios.get(url)
}

// 更新消息推送信息
export function updateOne(data) {
  const url = global.requestUrl + '/projectConfig/update'
  return axios.post(url, data)
}

